<template>
  <div class="main-bar">
    <div class="container">
      <div
        class="icon nav-toggler"
        @click="$f.showNav()"
      >
        <f-sprite-icon :icon-link="$options.icons.IconNav.id" />
      </div>

      <component
        class="logo"
        :is="$route.name === 'MainPage' ? 'div' : 'a'"
        :href="$route.name !== 'MainPage' && '/'"
      >
        <f-sprite-icon :icon-link="$options.icons.IconLogo.id" />
      </component>

      <control-city />

      <a
        class="link stores"
        href="/stores"
      >
        Магазины
      </a>

      <a
        class="link phone"
        href="tel:+78007700101"
      >
        8 800 770 01 01
      </a>

      <vue-client-only>
        <div
          v-if="adaptive.isTablet"
          class="tablet-menu"
        >
          <tree-menu
            :items="MENU"
            :max-depth="1"
          />
        </div>

        <div class="icons">
          <div
            class="icon"
            @click="$f.toggleSearch"
            v-if="adaptive.isDesktop"
          >
            <f-sprite-icon :icon-link="$options.icons.IconSearch.id" />
          </div>
          <control-promotions v-if="isPromotionsShown" />
          <control-user v-if="isProfileShown" />
          <control-favorites class="icon" v-if="isFavoritesShown" />
          <control-cart v-if="isCartShown" />
        </div>
      </vue-client-only>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VueClientOnly from 'vue-client-only';

/* Icons */
import IconNav from '@icons/nav-toggler.svg';
import IconLogo from '@images/logo.multi.svg';
import IconSearch from '@icons/search.svg';
/* Components */
import ControlUser from './control-user.vue';
import ControlCart from './control-cart.vue';
import treeMenu from './tree-menu.vue';
import ControlCity from './control-city.vue';
import ControlPromotions from './control-promotions';
import ControlFavorites from './control-favorites';

import { isCsmAddProduct, isCsmCreateBasket } from '@/utils/csm-cookies';

export default {
  name: 'main-bar',
  components: {
    ControlPromotions,
    treeMenu,
    ControlUser,
    ControlCart,
    ControlCity,
    ControlFavorites,
    VueClientOnly,
  },
  inject: ['adaptive'],
  icons: {
    IconLogo,
    IconNav,
    IconSearch,
  },
  computed: {
    ...mapGetters({
      MENU: 'menu/mainMenu',
      LOGGED_IN: 'user/loggedIn',
    }),
    isSomeCsmMode() {
      return !isCsmAddProduct() && !isCsmCreateBasket();
    },
    isProfileShown() {
      return this.isSomeCsmMode && this.adaptive.isDesktop;
    },
    isPromotionsShown() {
      return this.isSomeCsmMode && (this.adaptive.isDesktop && this.LOGGED_IN)
    },
    isFavoritesShown() {
      return this.isSomeCsmMode;
    },
    isCartShown() {
      return !isCsmAddProduct();
    }
  },
}
</script>

<style lang="scss">
.main-bar {
  // 56px
  padding: 16px 0;
  background: $white;

  .logo {
    width: 120px;
    height: 24px;
  }

  .icon {
    color: $black;
  }

  .nav-toggler {
    margin-right: 16px;
  }

  .container {
    display: flex;
    > .link {
      display: none;
    }
  }

  .icons {
    position: relative;
    display: flex;
    margin-left: auto;
    > * {
      margin-left: 15px;
    }

    .icon {
      position: relative;
      cursor: pointer;
      height: 20px;
      width: 20px;
      .ui-badge {
        position: absolute;
        font-size: 10px;
        line-height: 17px;
        min-width: 16px;
        height: 16px;
        padding: 0 2px;
        top: -6px;
        left: 12px;
      }
    }
  }

  @include breakpoint("tablet") {
    .icons {
      > * {
        margin-left: 40px;
      }
    }
  }
}

@include breakpoint("desktop") {
  .main-bar {
    // 72px
    padding: 21px 0 11px;

    .logo {
      width: 204px;
      height: 30px;
    }

    .nav-toggler {
      display: none;
    }

    .container > .link {
      display: flex;
      margin-left: 34px;
      padding: 7px 0;
      color: $black;
      font-size: 14px;
      line-height: 16px;
    }

    .icons {
      height: 40px;

      .icon {
        width: 24px;
        height: 24px;
        margin-left: 40px;

        &:first-child {
          margin-left: 0;
        }

        .ui-badge {
          font-size: 11px;
          line-height: 21px;
          min-width: 20px;
          height: 20px;
          padding: 0 6px;
          top: -10px;
          left: 14px;
          .ui-loader {
            margin: 3px -3px;
          }
        }
      }

      .dropdown {
        display: block;
        position: absolute;
        top: 36px;
        right: 0;
      }
    }
  }
}
</style>
